import { FormattedContent } from '@jotta/ui/FormattedContent'
import { RadixDialog } from '@jotta/ui/RadixDialog'
import { RadixModal } from '@jotta/ui/RadixModal'
import { t } from '@lingui/macro'

export const ConfirmDeleteDialog: React.FC<{
  open?: boolean
  onConfirm: () => void
  onClose: () => void
}> = ({ onConfirm, onClose, open = false }) => {
  const confirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <RadixModal open={open} onClose={onClose}>
      <RadixDialog
        title={t`DeleteCommentDialog.confirmTitle`}
        buttons={[
          { action: onClose, label: t`Cancel`, type: 'outline' },
          {
            action: confirm,
            label: t`DeleteCommentDialog.confirmLabel`,
            type: 'destructive',
          },
        ]}
      >
        <FormattedContent>
          <p>{t`DeleteCommentDialog.confirmBody`}</p>
        </FormattedContent>
      </RadixDialog>
    </RadixModal>
  )
}
